class GoogleAuthenticationForm {
  constructor() {
    this.secret = null;
    this.code = null;

    this.errors = {};
  }

  setErrors(errors) {
    this.errors['code'] = errors['errors'];
    if (this.errors['code'] && Array.isArray(this.errors['code']) && Array.isArray(errors.children.code.errors)) {
      this.errors['code'].push(...errors.children.code.errors);
    }
  }

  toPayload() {
    return {
      memberAuthenticationCode: {
        secret: this.secret,
        code: this.code 
      }
    };
  }
}

export default GoogleAuthenticationForm;



// WEBPACK FOOTER //
// ./client/app/pages/settings/component/transaction-authentication/google-authentication/google-authentication.form.js